import React, { useEffect } from "react";
import { motion } from 'framer-motion';
import { FiSmartphone, FiServer, FiCpu } from 'react-icons/fi';
import { SectionHeader } from './ui';
import '../assets/styles/Expertise.scss';
import { trackSectionView } from '../utils/mixpanel';

const skills = [
  {
    icon: <FiSmartphone />,
    title: 'Mobile App Development',
    description: 'I build high-quality mobile applications from scratch using Native Android, Native iOS, React Native, and Kotlin Multiplatform (KMP). Strong proficiency in the full mobile SDLC with expertise in integrating AI and LLM-powered features directly into mobile apps.',
    tags: ['Kotlin', 'Java', 'Swift', 'Android', 'iOS', 'React Native', 'KMP', 'AI Integration', 'On-Device AI', 'Core ML', 'MediaPipe', 'LLM', 'OpenAI', 'SQL', 'MVVM', 'Clean Architecture', 'Jetpack Compose', 'Retrofit'],
  },
  {
    icon: <FiServer />,
    title: 'Backend, DevOps & Automation',
    description: 'I architect scalable backend systems, CI/CD pipelines, and deployment automation for a successful Go-Live. Building robust backends with Laravel, Spring Boot, Flask, and Shopify embedded apps — with seamless AI API integrations including OpenAI, Claude, and LLM providers.',
    tags: ['Laravel', 'Spring Boot', 'PHP', 'Python', 'Flask', 'Shopify', 'Shopify Embedded Apps', 'AI APIs', 'Vector Search', 'RAG', 'Git', 'GitHub Actions', 'Docker', 'AWS', 'Azure', 'Linux', 'Snowflake'],
  },
  {
    icon: <FiCpu />,
    title: 'GenAI, Computer Vision & LLM',
    description: 'I leverage Generative AI, LLMs, and Computer Vision to build intelligent solutions that automate workflows and enhance decision-making. From RAG pipelines and AI agents to real-time object detection and AR-enabled apps — delivering enterprise-grade AI across mobile and web platforms.',
    tags: ['OpenAI', 'Claude API', 'Gemini', 'Groq', 'LangChain', 'LlamaIndex', 'Pinecone', 'RAG', 'AI Agents', 'Prompt Engineering', 'Hugging Face', 'Computer Vision', 'Augmented Reality', 'Machine Learning'],
  },
];

function Expertise() {
  useEffect(() => {
    trackSectionView('expertise');
  }, []);

  return (
    <section className="expertise" id="expertise">
      <div className="expertise__container">
        <SectionHeader
          title="Expertise"
          subtitle="What I bring to the table — from mobile to backend to AI."
          align="left"
        />

        <div className="expertise__grid">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.title}
              className="expertise__card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="expertise__icon">
                {skill.icon}
              </div>
              <h3 className="expertise__card-title">{skill.title}</h3>
              <p className="expertise__card-desc">{skill.description}</p>
              <div className="expertise__tags">
                {skill.tags.map((tag) => (
                  <span key={tag} className="expertise__tag">{tag}</span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Expertise;
